module.exports = __webpack_public_path__ + "img/xujiaxin.19f7126f.jpg";